module.exports = __webpack_public_path__ + "SiddharthChari-dcf064a7.webp";